import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, useRestaurant } from '../../hooks';
import { SETUP_RESTAURANT_PATH } from '../../utils/ownerDefaultRoute';

export function RestaurantGuard({ children }) {
    const { isInitialized, isOwner } = useAuth();
    const { restaurants, restaurantsLoaded } = useRestaurant();
    const location = useLocation();

    if (!isInitialized || (isOwner() && !restaurantsLoaded)) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600" />
            </div>
        );
    }

    if (!isOwner()) {
        return children;
    }

    const hasRestaurants = restaurants.length > 0;
    const isSetupRoute = location.pathname === SETUP_RESTAURANT_PATH;

    if (isSetupRoute && hasRestaurants) {
        return <Navigate to="/restaurants" replace />;
    }

    if (!isSetupRoute && !hasRestaurants) {
        return <Navigate to={SETUP_RESTAURANT_PATH} replace />;
    }

    return children;
}
